module.exports = __webpack_public_path__ + "static/media/team-spirit.d0fb61c1.svg";